import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import {
  Box,
  Heading,
  Stack,
  Text,
  TextLink,
  useResponsiveValue
} from '@machobear/design-system'

import emailIcon from '@/features/Company/icons/email-icon.png'
import phoneIcon from '@/features/Company/icons/phone-icon.png'
import Head from '@/components/head'

import heroBanner from './vanpmmaster_banner.jpeg'
import vanpmmasterQr from './vanpmmaster_qr.jpeg'

const VancouverPropertyManagementProfile = ({
  metadata,
  footerOnScreen,
  listingsOnScreen
}) => {
  const { t } = useTranslation('vancouverpropertymanagementmaster')
  const profile = {
    banner: heroBanner.src,
    title: 'Vancouver Property Management',
    url: '/company/vancouverpropertymanagementmaster'
  }

  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false,
    desktop: false
  })

  const isDesktop = useResponsiveValue()({
    mobile: false,
    tablet: false,
    desktop: true
  })

  return (
    <>
      <Head
        title={`${profile.title} | liv.rent`}
        description={profile.pageDescription}
        path={profile.url}
        pageData={metadata}
        hideCustomerSupport
      />
      <Box
        style={{ height: isMobile ? '210px' : isDesktop ? '500px' : '350px' }}
        marginBottom="medium"
        overflow="hidden"
        position="relative"
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="full"
          width="full"
          overflow="hidden"
        >
          <Image
            fill
            priority
            src={heroBanner.src}
            alt="Concert Realty Banner"
            style={{
              objectFit: 'cover',
              objectPosition: '50% 50%'
            }}
            sizes="(max-width: 768px) 768px, (max-width: 1200px) 1200px"
          />
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection={{ mobile: 'column', tablet: 'row' }}
        gap="gutter"
        justifyContent="center"
        marginY="large"
      >
        <Stack space="medium">
          <Box
            display="flex"
            alignItems="center"
            marginRight="large"
            marginLeft="medium"
          >
            <Heading level="3" weight="weak">
              {t(
                'vancouverpropertymanagementmaster:Vancouver Property Management Master'
              )}
            </Heading>
          </Box>
          <Box
            display="flex"
            flexDirection={{ mobile: 'column', tablet: 'row' }}
            gap={{ mobile: 'gutter', tablet: 'none' }}
            marginX="medium"
            marginBottom={{
              mobile: 'medium',
              tablet: 'medium',
              desktop: 'xlarge'
            }}
            marginTop="medium"
            style={{
              maxWidth: '1096px'
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              style={{
                width: isMobile ? '100%' : 'fit-content'
              }}
            >
              <Stack space="medium">
                <Stack space="gutter">
                  <Text size="standard" weight="strong">
                    {t('vancouverpropertymanagementmaster:subtitle')}
                  </Text>
                  <Text size="standard">
                    {t('vancouverpropertymanagementmaster:description')}
                  </Text>
                </Stack>
              </Stack>
            </Box>
          </Box>
        </Stack>
        <Box
          display="flex"
          flexDirection="column"
          gap="medium"
          background="neutralSoft"
          borderRadius="small"
          paddingY="small"
          paddingX="gutter"
          marginX="medium"
          style={{
            height: 'min-content',
            minWidth: '250px'
          }}
        >
          <Stack space="xsmall">
            <Box display="flex" alignItems="center" width="full">
              <Text size="small" weight="strong">
                Michael Y. Liu
              </Text>
            </Box>
            <Box display="flex" alignItems="center" width="full">
              <Text size="small">Remax Crest Realty</Text>
            </Box>
          </Stack>

          <Box display="flex" alignItems="center" width="full">
            <Box marginRight="xxsmall">
              <Image src={emailIcon.src} alt="" width={16} height={16} />
            </Box>
            <TextLink
              href="mailto: vanpmmaster@gmail.com"
              rel="noreferrer noopener"
            >
              vanpmmaster@gmail.com
            </TextLink>
          </Box>
          <Box display="flex" alignItems="center" width="full">
            <Box marginRight="xxsmall">
              <Image src={phoneIcon.src} alt="" width={16} height={16} />
            </Box>
            <TextLink href={`tel: 778 999 1662`} rel="noreferrer noopener">
              778-999-1662
            </TextLink>
          </Box>
        </Box>
      </Box>
      <Box textAlign="center" paddingBottom="gutter">
        <Heading level="6">
          {t('vancouverpropertymanagementmaster:Our Portfolio')}
        </Heading>
      </Box>
      {isDesktop && (
        <Box
          position={footerOnScreen && listingsOnScreen ? 'absolute' : 'fixed'}
          zIndex="dropdown"
          border="borderNeutralLight"
          background="bodyWhite"
          display={{ mobile: 'none', tablet: 'none', desktop: 'flex' }}
          style={{
            top: !footerOnScreen && !listingsOnScreen ? '1000px' : null,
            bottom: '20px',
            right: '10px'
          }}
          paddingBottom="xsmall"
        >
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            justifyContent="center"
            gap="xsmall"
            style={{ width: '158px', height: '175px' }}
          >
            <Image
              src={vanpmmasterQr}
              alt="Vancouver Property Managment Qr"
              width={160}
              height={160}
              placeholder="blur"
            />
            <Text align="center" size="xsmall" weight="medium">
              {t('vancouverpropertymanagementmaster:QR description')}
            </Text>
          </Box>
        </Box>
      )}
    </>
  )
}

export default VancouverPropertyManagementProfile
